export const orange = '#FF5733';

export const blue = '#0088CC';

export const light_blue = '#33D7FF';

export const yellow = '#EDD170';

export const red = '#C05640';

export const green = '#258039';

export const cyan = '#1ECFD6';

export const rating1 = blue;
export const rating2 = cyan;
export const rating3 = yellow;



// WEBPACK FOOTER //
// ./src/utils/Theme.js